module.exports = "/_next/static/images/changenow-34b0b7d8302ddd2780301b97abdbcf4e.png";